var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-menu"},[_c('div',{staticClass:"flex items-center w-full h-20"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }